import React, { useState } from 'react';
import ModalContainer from '../ModalContainer';
import styled from '@emotion/styled';
import { WhatsappFill } from '../../Icons/WhatsappFill';
import { TelegramFill } from '../../Icons/TelegramFill';
import { XFill } from '../../Icons/XFill';
import { FacebookSolid } from '../../Icons/Facebook';
import { LinkedinSolid } from '../../Icons/LinkedIn';

const ShareJobModal: React.FC = () => {
  const [copied, setCopied] = useState(false);
  const shareUrl = typeof window !== 'undefined' ? window.location.href : '';

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // ignore write errors
    }
  };

  return (
    <ModalContainer width="600px" padding="1rem">
      <Container>
        <Label>Share this job</Label>
        <UrlInputWrapper>
          <UrlInput
            type="text"
            value={shareUrl}
            readOnly
            aria-label="Job URL"
            onFocus={(e) => e.currentTarget.select()}
          />
        </UrlInputWrapper>

        <Actions>
          <CopyButton type="button" onClick={handleCopy} disabled={copied}>
            {copied ? 'Link Copied' : 'Copy Link'}
          </CopyButton>

          <ShareLink
            href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
              shareUrl
            )}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <WhatsappFill />
          </ShareLink>

          <ShareLink
            href={`https://t.me/share/url?url=${encodeURIComponent(shareUrl)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <TelegramFill />
          </ShareLink>

          <ShareLink
            href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(
              shareUrl
            )}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <XFill />
          </ShareLink>

          <ShareLink
            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
              shareUrl
            )}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FacebookSolid />
          </ShareLink>

          <ShareLink
            href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
              shareUrl
            )}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <LinkedinSolid />
          </ShareLink>
        </Actions>
      </Container>
    </ModalContainer>
  );
};

export default ShareJobModal;

// ===== Styled Components =====

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Label = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 500;
`;

const UrlInputWrapper = styled.div`
  width: 100%;
`;

const UrlInput = styled.input`
  width: 100%;
  padding: 0.5rem;
  font-size: 0.9rem;
  border: 1px solid ${({ theme }) => theme.palette.greyGrey3};
  border-radius: 4px;
  background: ${({ theme }) => theme.palette.white};
  color: ${({ theme }) => theme.palette.blackBlackMain};
  cursor: text;
`;

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

const CopyButton = styled.button`
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  font-weight: 500;
  border: 1px solid ${({ theme }) => theme.palette.mainPurple};
  background-color: ${({ theme }) => theme.palette.mainPurple};
  color: ${({ theme }) => theme.palette.white};
  border-radius: 4px;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const ShareLink = styled.a`
  padding: 0.5rem 0.75rem;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.palette.mainBlue};
  text-decoration: none;
  background-color: ${({ theme }) => theme.palette.greyGrey4};
  border-radius: 4px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  margin: 0.25rem;

  &:hover {
 transform: scale(1.2);
  }
`;
